'use client';

import { ReactNode, Suspense } from 'react';
import { CartProvider } from '@/contexts/CartContext';
import CartSidebar from '@/components/CartSidebar';
import { PostHogProvider, PostHogPageview } from '@/components/PostHogProvider';

export default function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <PostHogProvider>
      <CartProvider>
        <Suspense fallback={null}>
          <PostHogPageview />
        </Suspense>
        {children}
        <CartSidebar />
      </CartProvider>
    </PostHogProvider>
  );
}
